import { render, staticRenderFns } from "./details.vue?vue&type=template&id=067a3346"
import script from "./details.ts?vue&type=script&lang=js&external"
export * from "./details.ts?vue&type=script&lang=js&external"
import style0 from "./details.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports